<template>
  <div>
    <el-upload
      :show-file-list="false"
      :file-list="[]"
      :action="uploadUrl"
      :on-success="handlePictureCardPreview"
      :before-upload="beforeVideoUpload1"
      :headers="headers"
      name="files"
      :limit="1"
      :multiple="false"
      accept=".jpg,.jpeg,.png,.wav,.mp3"
    >
      <div class="upload-image">
        <span class="txt" v-if="!picture">
          + 产品图上传/已选定的AI图片 替换/删除</span
        >
        <el-image
          v-else
          class="urlImage"
          :src="picture"
          fit="scale-down"
        ></el-image>
        <div class="actionBtn">
          <img
            v-if="picture"
            class="preview"
            src="https://image2.soole.com.cn/slb-picture2025102115062619168.jpg"
            @click="handlePictureCardPreview1"
            alt=""
          />
          <i
            class="el-icon-delete dele"
            v-if="picture"
            @click.stop="handleRemove"
          ></i>
        </div>
      </div>
    </el-upload>
    <!-- <el-button
      v-if="picture"
      class="btn"
      type="primary"
      @click="handlePictureCardPreview1"
      >图片预览</el-button
    > -->

    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="点击进行预览"
      width="40%"
    >
      <!-- <img width="100%" :src="picture" alt="" /> -->
      <div class="imageBox">
        <el-image
          class="previewImage"
          :src="picture"
          fit="scale-down"
          :preview-src-list="[picture]"
        ></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: false,
      picture: "",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      uploadUrl: process.env.VUE_APP_API + "/api/common/fileInfo/newUpload",
    };
  },
  watch: {
    "props.value": {
      handler(newVal) {
        this.picture = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    handlePictureCardPreview1(e) {
      e.stopPropagation();
      this.dialogVisible = true;
    },
    // 上传视频背景图片限制
    beforeVideoUpload1(file, fileList) {
      return new Promise((resolve, reject) => {
        const isImage = file.type.includes("image/");
        if (!isImage) {
          this.$message.error("只能上传图片文件");
          return reject();
        }

        const isLt5M = file.size / 1024 / 1024 < 10;
        if (!isLt5M) {
          this.$message.error("图片大小不能超过 10MB");
          return reject();
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = (e) => {
          const image = new Image();
          image.src = e.target.result;
          resolve();
        };

        reader.onerror = () => {
          this.$message.error("图片读取失败");
          reject();
        };
      });
    },
    // 分辨率校验
    validateDimensions(width, height) {
      if (this.type == 3) {
        if (width == 1080 && height == 1920) return true;
      } else if (this.type == 4) {
        if (height == 1080 && width == 1920) return true;
      } else {
        return false;
      }
    },
    handlePictureCardPreview(response) {
      if (Array.isArray(response.data) && response.data.length > 0) {
        this.picture = response.data[0].fileUrl;
        this.$emit("success", this.picture);
      }
    },
    search(imageUrl) {
      this.picture = imageUrl;
    },
    handleRemove() {
      // 删除图片
      this.picture = "";
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  margin-top: 15px;
  float: right;
}
.imageBox {
  display: flex;
  justify-content: center;
  align-items: center;
}
.previewImage {
  text-align: center;
}
.upload-image {
  position: relative;
  border: 1px dashed #999;
  width: 375px;
  height: 375px;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    width: 26px;
    height: 26px;
  }

  .urlImage {
    width: 100%;
    height: 100%;
  }
  .tips {
    font-size: 12;
    color: #999;
  }
  .txt {
    color: #999;
  }
}
.actionBtn {
  position: absolute;
  display: flex;
  align-items: center;
}
.dele {
  color: #fff;
  z-index: 999;
  font-size: 36px;
}
.preview {
  width: 36px;
  margin-right: 16px;
}
</style>
